import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import TagManager from 'react-gtm-module';

export const GtmInjection = ({ children }) => {
  const { getEnv } = Sebrae.useEnv();
  React.useEffect(() => {
    getEnv('GTMID')
      .then((response) => {
        TagManager.initialize({ gtmId: `${response}` });
      })
      .catch((error) => console.log(error));
  }, [getEnv]);

  return <section>{children}</section>;
};
